import { DirectiveBinding } from "vue"

export default {
  beforeMount(el: HTMLElement, binding: DirectiveBinding) {
    toggleVisibility(el, binding.value)
  },
  updated(el: HTMLElement, binding: DirectiveBinding) {
    toggleVisibility(el, binding.value)
  },
}

function toggleVisibility(el: HTMLElement, value: DirectiveBinding) {
  if (value) {
    el.classList.remove('tw:invisible')
    el.classList.add('tw:visible')
  } else {
    el.classList.remove('tw:visible')
    el.classList.add('tw:invisible')
  }
}
